import React, { useContext, useState, useMemo } from "react";
import config from "../../config";
import DateTime from "../../Components/DateTime";
import dayjs from "dayjs";
import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Checkbox,
  TableSortLabel,
  TextField,
  InputAdornment,
  Box,
  Dialog,
  DialogContent,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { UserContext } from "../../Layout";
import { Search, Close as CloseIcon } from "@mui/icons-material";
import { APIServices } from "../../helpers/APIServices";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { parseStatus, parseFullNameFromUser } from "../../helpers/common";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeletePaperModal from "../../Components/DeletePaperModal";
import SimpleBackdrop from "../../Components/Backdrop";
import _ from "lodash";
import { 
  CalendarToday as CalendarIcon, 
  FilterList as FilterIcon 
} from "@mui/icons-material";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
const getStartDateFilter = () => {
  const value = localStorage.getItem("filterQCASP");
  return value ? JSON.parse(value)?.startDate : undefined;
};
const setStartDateFilter = (startDate) => {
  const oldValue = localStorage.getItem("filterQCASP") || "{}";
  const newValue = {
    ...JSON.parse(oldValue),
    startDate,
  };
  localStorage.setItem("filterQCASP", JSON.stringify(newValue));
};

const getEndDateFilter = () => {
  const value = localStorage.getItem("filterQCASP");
  return value ? JSON.parse(value)?.endDate : undefined;
};
const setEndDateFilter = (endDate) => {
  const oldValue = localStorage.getItem("filterQCASP") || "{}";
  const newValue = {
    ...JSON.parse(oldValue),
    endDate: endDate,
  };
  localStorage.setItem("filterQCASP", JSON.stringify(newValue));
};

const CustomDateHistoryAll = ({
  partData,
  searchTerm,
  setSearchTerm,
  onSearch,
  onKeyDown,
  onClearSearch,
  activeSearch,
  statusFilters,
  setStatusFilters,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  order,
  setOrder,
  orderBy,
  setOrderBy,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  //console.log(partData);
  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(startDate || dayjs().subtract(1, "day").startOf("day").toISOString());
  const [tempEndDate, setTempEndDate] = useState(endDate || dayjs().endOf("day").toISOString());
  const [partsId, setPartIds] = useState();
  const [loading, setLoading] = useState(false);

  const user = useContext(UserContext);
  const role = user.qc_role;
  const { id } = useParams();
  const [openDelete, setOpenDelete] = useState({
    open: false,
    message: "",
  });
  const [apiSuccess, setapiSuccess] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [jumpPage, setJumpPage] = useState(page + 1);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    setJumpPage(page + 1);
  }, [page]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0); // Reset page on sort
  };

  //   const handleOnChangeStartDate = (date, time) => {
  //     if (!date || !time) {
  //       setStartDate((prev) => ({
  //         ...prev,
  //         value: undefined,
  //       }));
  //       return;
  //     }
  //     const startDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
  //     setStartDate((prev) => ({
  //       ...prev,
  //       value: startDate,
  //       error: false,
  //     }));
  //     setStartDateFilter(startDate);
  //   };

  //   const handleOnChangeEndDate = (date, time) => {
  //     if (!date || !time) {
  //       setEndDate((prev) => ({
  //         ...prev,
  //         value: undefined,
  //       }));
  //       return;
  //     }
  //     const endDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
  //     setEndDate((prev) => ({
  //       ...prev,
  //       value: endDate,
  //       error: false,
  //     }));
  //     setEndDateFilter(endDate);
  //   };
  //   const getPaper = async () => {
  //     setLoading(true);
  //     try {
  //       const startDateParsed = dayjs(startDate.value).toISOString();
  //       const endDateParsed = dayjs(endDate.value).toISOString();
  //       const response = await APIServices.getPaper(
  //         startDateParsed,
  //         endDateParsed,
  //         id,
  //         user
  //       );

  //       const papersData = response.data?.data;
  //       if (Array.isArray(papersData) && papersData.length > 0) {
  //         setPapers(papersData);

  //         const firstPaper = papersData[0];
  //         const partId = firstPaper?.attributes?.answer?.partId;

  //         if (partId) {
  //           setPartIds(partId);
  //         } else {
  //           console.warn("partId not found in the response data.");
  //         }
  //       } else {
  //         console.warn(
  //           "No papers data found or response structure is not as expected.",
  //           {
  //             receivedData: response.data,
  //             parsedData: papersData,
  //           }
  //         );
  //       }

  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching papers:", error);
  //       setLoading(false);
  //     }
  //   };

  //   const submitSearch = async () => {
  //     getPaper();
  //   };

  const deletePaper = async (result, row) => {
    if (result) {
      setLoading(true);
      await APIServices.updateDeletePaper(true, row.id);
      setTimeout(() => {
        setLoading(false);
        setapiSuccess(true);
      }, 1000);
    }
  };

  const handleOnClickDelete = (row) => {
    setSelectedRow(row);
    let message = "ลบข้อมูลใช่หรือไม่";
    setOpenDelete({ open: true, message: message });
  };

  const Action = ({ row, index }) => {
    if (role === "super_admin") {
      return (
        <>
          <Link
            key={"view_paper_v2"}
            to={`view_paper_v2/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <VisibilityIcon />
            </IconButton>
          </Link>
          <Link
            key={"edit_paper_v3"}
            to={`edit_paper_v3/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
          <IconButton color="error" onClick={() => handleOnClickDelete(row)}>
            <DeleteIcon />
          </IconButton>
        </>
      );
    }
    if (role === "inspector") {
      return (
        <>
          <Link
            key={"view_paper_v2"}
            to={`view_paper_v2/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <VisibilityIcon />
            </IconButton>
          </Link>
          <Link
            key={"edit_paper_v3"}
            to={`edit_paper_v3/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
          <IconButton color="error" onClick={() => handleOnClickDelete(row)}>
            <DeleteIcon />
          </IconButton>
        </>
      );
    } else if (role === "checker" || role === "approver" || role === "admin" || role === "viewer") {
      return (
        <Link
          key={"view_paper_v2"}
          to={`view_paper_v2/${row.id}`}
          state={{ index: index + 1 }}
        >
          <IconButton color="primary">
            <VisibilityIcon />
          </IconButton>
        </Link>
      );
    } else {
      return (
        <Link
          key={"view_paper_v2"}
          to={`view_paper_v2/${row.id}`}
          state={{ index: index + 1 }}
        >
          <IconButton color="primary">
            <VisibilityIcon />
          </IconButton>
        </Link>
      );
    }
  };

  // useEffect(() => {
  //   console.log(partsId);
  // }, [partsId]);

  const currentRows = partData?.data || [];
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("pending_page_1", newPage.toString());
  };

  return (
    <div className="">
      <SimpleBackdrop open={loading} setOpen={setLoading} />
      <TableContainer component={Paper}>
        <div className={`p-4`}>
          <div className={`h-full flex items-end pb-1 text-xl`}>
            รายการทั้งหมดที่รอการอนุมัติ
            {partData?.total !== undefined && (
              <span className="ml-2 text-sm text-gray-500">
                (ทั้งหมด {partData.total} รายการ)
              </span>
            )}
          </div>
          <div className={`mt-2 flex justify-between items-end`}>
            <div className={`flex items-end gap-4 w-full`}>
              <FormGroup row className="flex items-center gap-1">
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={statusFilters.includes("1")}
                      onChange={() =>
                        setStatusFilters((prev) =>
                          prev.includes("1")
                            ? prev.filter((s) => s !== "1")
                            : [...prev, "1"],
                        )
                      }
                    />
                  }
                  label={parseStatus("1")}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={statusFilters.includes("2")}
                      onChange={() =>
                        setStatusFilters((prev) =>
                          prev.includes("2")
                            ? prev.filter((s) => s !== "2")
                            : [...prev, "2"],
                        )
                      }
                    />
                  }
                  label={parseStatus("2")}
                />
                {role !== "checker" && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={statusFilters.includes("4")}
                        onChange={() =>
                          setStatusFilters((prev) =>
                            prev.includes("4")
                              ? prev.filter((s) => s !== "4")
                              : [...prev, "4"],
                          )
                        }
                      />
                    }
                    label={parseStatus("4")}
                  />
                )}
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={statusFilters.includes("3")}
                      onChange={() =>
                        setStatusFilters((prev) =>
                          prev.includes("3")
                            ? prev.filter((s) => s !== "3")
                            : [...prev, "3"],
                        )
                      }
                    />
                  }
                  label={parseStatus("3")}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={statusFilters.includes("5")}
                      onChange={() =>
                        setStatusFilters((prev) =>
                          prev.includes("5")
                            ? prev.filter((s) => s !== "5")
                            : [...prev, "5"],
                        )
                      }
                    />
                  }
                  label={parseStatus("5")}
                />
              </FormGroup>
              <div className="flex-grow"></div>
              <div className="flex items-center gap-2">
                <TextField
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={onKeyDown}
                  placeholder="ค้นหาชื่อหรือรหัสชิ้นส่วน แล้วกด Enter..."
                  sx={{ width: 300 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={onSearch}
                  sx={{ minWidth: 80 }}
                >
                  ค้นหา
                </Button>
                <IconButton 
                  onClick={() => {
                    setTempStartDate(startDate || dayjs().subtract(1, "day").startOf("day").toISOString());
                    setTempEndDate(endDate || dayjs().endOf("day").toISOString());
                    setOpenDateDialog(true);
                  }}
                  color={(startDate || endDate) ? "primary" : "default"}
                  sx={{ 
                    border: "1px solid", 
                    borderColor: (startDate || endDate) ? "primary.main" : "divider",
                    borderRadius: 1
                  }}
                >
                  <CalendarIcon fontSize="small" />
                </IconButton>
                {(activeSearch || startDate || endDate) && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      onClearSearch();
                      setStartDate("");
                      setEndDate("");
                    }}
                    color="error"
                  >
                    ล้างทั้งหมด
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
        <Table sx={{ minWidth: 550 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "100px" }}>
                ชิ้นส่วน
              </TableCell>
              {role === "inspector" && (
                <TableCell align="center">ครั้งที่</TableCell>
              )}
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "create_datetime"}
                  direction={orderBy === "create_datetime" ? order : "asc"}
                  onClick={() => handleRequestSort("create_datetime")}
                >
                  วันและเวลา
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "part_name"}
                  direction={orderBy === "part_name" ? order : "asc"}
                  onClick={() => handleRequestSort("part_name")}
                >
                  Part Name
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">Part No</TableCell>
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "status"}
                  direction={orderBy === "status" ? order : "asc"}
                  onClick={() => handleRequestSort("status")}
                >
                  Status
                </TableSortLabel>
              </TableCell>
              {(role === "checker" ||
                role === "approver" ||
                role === "super_admin" ||
                role === "admin" ||
                role === "viewer") && (
                <TableCell align="center">
                  <TableSortLabel
                    active={orderBy === "inspector"}
                    direction={orderBy === "inspector" ? order : "asc"}
                    onClick={() => handleRequestSort("inspector")}
                  >
                    Inspector
                  </TableSortLabel>
                </TableCell>
              )}
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "checker"}
                  direction={orderBy === "checker" ? order : "asc"}
                  onClick={() => handleRequestSort("checker")}
                >
                  Checker
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "approver"}
                  direction={orderBy === "approver" ? order : "asc"}
                  onClick={() => handleRequestSort("approver")}
                >
                  Approver
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">Revision</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRows.map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={row.id}
                  style={{ cursor: "pointer" }}
                >
                  <TableCell align="center">
                    <img
                      src={(() => {
                        const imgUrl =
                          row.attributes.partName?.data?.attributes?.image?.data
                            ?.attributes?.url ||
                          row.attributes.partName?.data?.attributes?.image
                            ?.data?.[0]?.attributes?.url ||
                          (typeof row.attributes.answer?.partImage === "string"
                            ? row.attributes.answer.partImage
                            : "");
                        if (!imgUrl) return "";
                        if (imgUrl.startsWith("http")) return imgUrl;
                        return `${config.server.replace(/\/$/, "")}${imgUrl}`;
                      })()}
                      onClick={() => {
                        const imgUrl =
                          row.attributes.partName?.data?.attributes?.image?.data
                            ?.attributes?.url ||
                          row.attributes.partName?.data?.attributes?.image
                            ?.data?.[0]?.attributes?.url ||
                          (typeof row.attributes.answer?.partImage === "string"
                            ? row.attributes.answer.partImage
                            : "");
                        if (imgUrl) {
                          const fullUrl = imgUrl.startsWith("http")
                            ? imgUrl
                            : `${config.server.replace(/\/$/, "")}${imgUrl}`;
                          setPreviewImage(fullUrl);
                        }
                      }}
                      style={{
                        width: 50,
                        height: 50,
                        objectFit: "cover",
                        borderRadius: 4,
                        border: "1px solid #ddd",
                        cursor: "pointer",
                      }}
                      alt="part"
                      onError={(e) => {
                        e.target.src =
                          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAALElEQVR42u3PMREAAAgEIDu/6GUpsBeYhU6SInDRpEiRIkWKFClSpEiRIkWK9LUBv0Y9AdM877gAAAAASUVORK5CYII=";
                      }}
                    />
                  </TableCell>
                  {role === "inspector" && (
                    <TableCell component="th" scope="row" align="center">
                      {index + 1}
                    </TableCell>
                  )}
                  <TableCell component="th" scope="row" align="center">
                    {row.attributes.create_datetime &&
                      dayjs(row.attributes.create_datetime).format(
                        "DD-MM-YYYY HH:mm",
                      )}
                  </TableCell>
                  <TableCell align="center">
                    <div className={`flex justify-center`}>
                      {row.attributes.partName?.data?.attributes?.part_name ||
                        row?.attributes?.answer?.partName}
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`flex justify-center`}>
                      {row.attributes.partName?.data?.attributes?.part_code ||
                        "-"}
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`flex justify-center`}>
                      {parseStatus(row.attributes.status)}
                    </div>
                  </TableCell>
                  {(role === "checker" ||
                    role === "approver" ||
                    role === "super_admin" ||
                    role === "admin" ||
                    role === "viewer") && (
                    <TableCell align="center">
                      {parseFullNameFromUser(
                        row.attributes.inspector_id?.data?.attributes,
                      )}
                    </TableCell>
                  )}
                  <>
                    <TableCell align="center">
                      {parseFullNameFromUser(
                        row.attributes.checker_id?.data?.attributes,
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {parseFullNameFromUser(
                        row.attributes.approver_id?.data?.attributes,
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {row.attributes.revision || "-"}
                    </TableCell>
                    <TableCell align="center">
                      <Action row={row} index={index} />
                    </TableCell>
                  </>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: 2,
          pb: 2,
          gap: 1,
        }}
      >
        <div className="text-sm text-gray-600">ไปที่หน้า:</div>
        <TextField
          size="small"
          type="number"
          value={jumpPage}
          onChange={(e) => setJumpPage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const newPage = parseInt(jumpPage) - 1;
              const maxPage = Math.ceil(partData.total / rowsPerPage) - 1;
              if (!isNaN(newPage) && newPage >= 0 && newPage <= maxPage) {
                setPage(newPage);
              } else if (newPage > maxPage) {
                setPage(maxPage);
                setJumpPage(maxPage + 1);
              } else {
                setJumpPage(page + 1);
              }
            }
          }}
          sx={{ width: 80 }}
          inputProps={{ min: 1, max: Math.ceil(partData.total / rowsPerPage) }}
        />
        <div className="text-sm text-gray-500">
          จากทั้งหมด {Math.ceil(partData.total / rowsPerPage)} หน้า
        </div>
      </Box>
      <TablePagination
        rowsPerPageOptions={[20, 50, 100]}
        component="div"
        count={partData.total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />
      <DeletePaperModal
        open={openDelete.open}
        setOpen={setOpenDelete}
        action={deletePaper}
        confirmText={"ใช่"}
        cancelText={"ยกเลิก"}
        header={"ยืนยันการลบข้อมูล"}
        message={
          <span>
            คุณต้องการ
            <span>{openDelete.message}</span>
          </span>
        }
        data={selectedRow}
      />
      <Dialog
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        maxWidth="lg"
      >
        <DialogContent sx={{ p: 0, position: "relative" }}>
          <IconButton
            onClick={() => setPreviewImage(null)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              bgcolor: "rgba(0,0,0,0.5)",
              color: "white",
              "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={previewImage}
            style={{ maxWidth: "100%", maxHeight: "90vh", display: "block" }}
            alt="preview"
          />
        </DialogContent>
      </Dialog>

      <Dialog 
        open={openDateDialog} 
        onClose={() => setOpenDateDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>เลือกช่วงเวลาที่ต้องการค้นหา</DialogTitle>
        <DialogContent dividers>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 1 }}>
              <DateTimePicker
                label="จากวันที่และเวลา"
                value={tempStartDate ? dayjs(tempStartDate) : null}
                onChange={(newValue) => setTempStartDate(newValue ? newValue.toISOString() : "")}
                slotProps={{ textField: { size: 'small', fullWidth: true } }}
              />
              <DateTimePicker
                label="ถึงวันที่และเวลา"
                value={tempEndDate ? dayjs(tempEndDate) : null}
                onChange={(newValue) => setTempEndDate(newValue ? newValue.toISOString() : "")}
                slotProps={{ textField: { size: 'small', fullWidth: true } }}
              />
            </Box>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setStartDate("");
            setEndDate("");
            setOpenDateDialog(false);
          }}>ล้างค่า</Button>
          <Button onClick={() => setOpenDateDialog(false)}>ยกเลิก</Button>
          <Button 
            variant="contained" 
            onClick={() => {
              setStartDate(tempStartDate);
              setEndDate(tempEndDate);
              setPage(0); // Reset page on filter change
              setOpenDateDialog(false);
            }}
          >
            ตกลง
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CustomDateHistoryAll;
